import React from 'react'

type AutoScrollContextType = {
  isAutoScrolling: boolean
  scrollSpeed: number
  toggleAutoScroll: () => void
  stopAutoScroll: () => void
  setScrollSpeed: (speed: number) => void
}

const AutoScrollContext = React.createContext<AutoScrollContextType>({
  isAutoScrolling: false,
  scrollSpeed: 3,
  toggleAutoScroll: () => {},
  stopAutoScroll: () => {},
  setScrollSpeed: () => {},
})

export function AutoScrollProvider({children}: {children: React.ReactNode}) {
  const [isAutoScrolling, setIsAutoScrolling] = React.useState(false)
  const [scrollSpeed, setScrollSpeed] = React.useState(50)

  const toggleAutoScroll = React.useCallback(() => {
    setIsAutoScrolling(prev => !prev)
  }, [])

  const stopAutoScroll = React.useCallback(() => {
    setIsAutoScrolling(false)
  }, [])

  const value = React.useMemo(
    () => ({
      isAutoScrolling,
      scrollSpeed,
      toggleAutoScroll,
      stopAutoScroll,
      setScrollSpeed,
    }),
    [isAutoScrolling, scrollSpeed, toggleAutoScroll, stopAutoScroll],
  )

  return (
    <AutoScrollContext.Provider value={value}>
      {children}
    </AutoScrollContext.Provider>
  )
}

export function useAutoScroll() {
  return React.useContext(AutoScrollContext)
}
